<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" data-test="listHeader">
        Locations - (Step 3 of 8)
    </ion-list-header>

    <ion-list class="ion-text-wrap">
        <ion-item detail="true" data-test="startingLocation" href="javascript:;" (click)="onStartingLocationClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Start Route At Dealership: {{isStartingRouteAtDealership()}}</span><br />
                <span class="line2">{{startingLocation.locationName}}</span><br />
                <span class="line2">{{startingLocation.address.fullAddress}}</span>
            </ion-label>
        </ion-item>

        <ion-item detail="true" data-test="endingLocation" href="javascript:;" (click)="onEndingLocationClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">End Route At Dealership: {{isEndingRouteAtDealership()}}</span><br />
                <span class="line2">{{endingLocation.locationName}}</span><br />
                <span class="line2">{{endingLocation.address.fullAddress}}</span>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext3">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>